/**
 * The figures' colours from the C64's sprite colours (spec 05 §4): each named ramp in
 * `content/palettes/sprites.json` is opened out from one of the sixteen C64 colours into four
 * steps - two shades, the colour itself, a tint - mixed in OKLab like the level colours.
 */

import c64 from '../../content/palettes/c64.json';
import sprites from '../../content/palettes/sprites.json';
import { hexToRgb8, mixOklab, type Rgb8, rgb8ToHex } from './color';

const BLACK: Rgb8 = [8, 6, 14];
const WHITE: Rgb8 = [255, 255, 255];

/** A four-step ramp, dark to light, around C64 colour `index`. */
export function c64Ramp(index: number): string[] {
  const hex = c64.colours[index];
  if (hex === undefined) throw new Error(`no C64 colour ${index}`);
  const c = hexToRgb8(hex);
  return [mixOklab(c, BLACK, 0.5), mixOklab(c, BLACK, 0.22), c, mixOklab(c, WHITE, 0.45)].map(rgb8ToHex);
}

/** Every figure ramp in the C64's colours. */
export function c64FigureRamps(): Record<string, string[]> {
  const out: Record<string, string[]> = {};
  for (const [name, index] of Object.entries(sprites.ramps)) out[name] = c64Ramp(index);
  return out;
}
